import { formatMoney, formatDate } from '../lib/money';
import { daysOverdue } from '../lib/aging';
import { getOutstanding, getDisplayStatus } from '../lib/invoiceCalc';

function InvoiceRow({ inv, paidFor, onOpen, onActions, firstAttachment, onPreviewFile }) {
  const paid = paidFor(inv.id);
  const outstanding = getOutstanding(inv, paid);
  const displayStatus = getDisplayStatus(inv, paid);
  const statusLabel = displayStatus.replace(/_/g, ' ');
  const days = displayStatus === 'paid' ? null : daysOverdue(inv.due_date);
  const agingText = days == null ? '—' : days === 0 ? '0' : days > 0 ? `-${days}` : `${Math.abs(days)}`;
  const agingColor = days == null ? 'var(--text-disabled)' : days > 0 ? 'var(--text-error)' : '#036e43';

  return (
    <div className={`gi-row row-status-${displayStatus}`} onClick={() => onOpen(inv)}>
      <div className="gi-cell gi-dot">
        {firstAttachment ? (
          <button type="button" className="file-eye-btn" onClick={e => { e.stopPropagation(); onPreviewFile?.(firstAttachment); }} title="Preview">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/></svg>
          </button>
        ) : (
          <span className="gi-dot-circle" />
        )}
      </div>
      <div className="gi-cell gi-supplier">{inv.supplier_name || '—'}</div>
      <div className="gi-cell gi-inv-num">{inv.invoice_number || 'N/A'}</div>
      <div className="gi-cell gi-po-tag">{inv.po_number_text ? <span className="po-tag">PO {inv.po_number_text}</span> : '—'}</div>
      <div className="gi-cell gi-date">{formatDate(inv.invoice_date)}</div>
      <div className="gi-cell gi-aging" style={{ color: agingColor }}>{agingText}</div>
      <div className="gi-cell gi-money">
        {formatMoney(inv.total || 0)}
        {inv.currency && inv.currency !== 'AUD' && (
          <div className="gi-cur-tag">{inv.currency} {Number(inv.total || 0).toLocaleString()}</div>
        )}
      </div>
      <div className="gi-cell gi-money gi-muted">{formatMoney(paid)}</div>
      <div className="gi-cell gi-money gi-hero">{formatMoney(outstanding)}</div>
      <div className="gi-cell"><span className={`status-pill ${displayStatus}`}>{statusLabel}</span></div>
      <div className="gi-cell">
        {onActions && <button type="button" className="row-actions-btn" onClick={e => { e.stopPropagation(); onActions(inv, e.currentTarget.getBoundingClientRect()); }}>
          <span>Actions</span><span className="caret">▸</span>
        </button>}
      </div>
    </div>
  );
}

export default function GeneralInvoiceList({ invoices, paidFor, onOpen, onActions, statusFilter, attachments = [], onPreviewFile }) {
  const filtered = statusFilter === 'all' ? invoices : invoices.filter(inv => {
    const ds = getDisplayStatus(inv, paidFor(inv.id));
    if (statusFilter === 'open') return ds !== 'paid' && ds !== 'disputed';
    if (statusFilter === 'disputed') return ds === 'disputed';
    if (statusFilter === 'paid') return ds === 'paid';
    return true;
  });

  if (filtered.length === 0) {
    return <div className="gi-empty">No invoices in this view</div>;
  }

  return (
    <div className="gi-table">
      <div className="gi-head">
        <div />
        <div>Supplier</div>
        <div>Invoice #</div>
        <div>PO</div>
        <div>Date</div>
        <div>Aging</div>
        <div className="gi-money-h">Total</div>
        <div className="gi-money-h">Paid</div>
        <div className="gi-money-h">Outstanding</div>
        <div>Status</div>
        <div>Actions</div>
      </div>
      {filtered.map(inv => (
        <InvoiceRow key={inv.id} inv={inv} paidFor={paidFor} onOpen={onOpen} onActions={onActions}
          firstAttachment={attachments.find(a => a.invoice_id === inv.id) || null}
          onPreviewFile={onPreviewFile} />
      ))}
    </div>
  );
}
